import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedService: null,
    cartItems: [],
    slotData: null,
    selectedAddons: [], // Array of selected add-on objects
    selectedVehicle: null, // Selected vehicle for booking
    selectedSubscription: null, // Selected subscription plan
    bookedData: null, // Store successful booking response
    loading: false,
    error: null,
};

const carWashSlice = createSlice({
    name: "carWash",
    initialState,
    reducers: {
        setSelectedService: (state, action) => {
            state.selectedService = action.payload;
            state.selectedSubscription = null; // Clear subscription when service is selected
        },
        setSelectedSubscription: (state, action) => {
            state.selectedSubscription = action.payload;
            // Clear service/cart data to avoid conflicts in Summary page
            state.selectedService = null;
            state.cartItems = [];
            state.selectedAddons = [];
            state.selectedVehicle = null;
            state.slotData = null;
        },
        addToCart: (state, action) => {
            // For now, we might just want to replace the cart with the single selected service 
            // or add to it. Based on the requirement "redirect us to Cart section with the service we have selected",
            // it implies a single service flow or adding to a list. 
            // Let's support adding to a list but also keeping track of the "current" selection.
            const newItem = action.payload;
            const existingItem = state.cartItems.find(item => item.id === newItem.id);

            if (!existingItem) {
                state.cartItems.push(newItem);
            }
            // Always update selected service when adding to cart
            state.selectedService = newItem;
            state.selectedSubscription = null; // Clear subscription when adding to cart
        },
        removeFromCart: (state, action) => {
            state.cartItems = state.cartItems.filter(item => item.id !== action.payload);
            if (state.selectedService?.id === action.payload) {
                state.selectedService = null;
            }
        },
        clearCart: (state) => {
            state.cartItems = [];
            state.selectedService = null;
            state.selectedSubscription = null;
            state.slotData = null;
            state.selectedAddons = [];
            state.selectedVehicle = null;
            state.bookedData = null;
        },
        setSlotData: (state, action) => {
            state.slotData = action.payload;
        },
        setSelectedAddons: (state, action) => {
            state.selectedAddons = action.payload;
        },
        setSelectedVehicle: (state, action) => {
            state.selectedVehicle = action.payload;
        },
        setBookedData: (state, action) => {
            state.bookedData = action.payload;
        },
    },
});

export const { setSelectedService, setSelectedSubscription, addToCart, removeFromCart, clearCart, setSlotData, setSelectedAddons, setSelectedVehicle, setBookedData } = carWashSlice.actions;

export default carWashSlice.reducer;
